module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("modal " + (_vm.wide ? 'wide' : ''))
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cb110a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 182
// module chunks = 2